module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/08dff6089c2812aaac7dc2ceed178351.png";